import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import { getCurrentDirection } from '@/i18n/config'

interface ToolButtonProps extends PropsWithChildren {
  onClick: () => void
  name: string
  isactive: boolean
  buttonClasses?: string 
  disabled?: boolean
}

const ToolButton = ({ name, children, onClick, isactive, buttonClasses, disabled }: ToolButtonProps) => {
  const btnClass = clsx(
    'p-2 hover:bg-purple-100 dark:hover:bg-purple-900/30 transition-all rounded-lg hover:text-purple-700 dark:hover:text-purple-400 data-[isActive=true]:text-purple-700 dark:data-[isActive=true]:text-purple-400 data-[isActive=true]:bg-purple-100 dark:data-[isActive=true]:bg-purple-900/30 disabled:opacity-50 disabled:cursor-not-allowed',
    buttonClasses,
  )
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className={btnClass}
            onClick={onClick}
            data-isactive={isactive}
            disabled={disabled}
          >
            {children}
          </button>
        </TooltipTrigger>
        <TooltipContent side={getCurrentDirection() === 'rtl' ? 'left' : 'right'}>
          <p className="capitalize">{name}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default ToolButton
